import { render, staticRenderFns } from "./appointmentData.vue?vue&type=template&id=40e6a6ce&scoped=true"
import script from "./appointmentData.vue?vue&type=script&lang=js"
export * from "./appointmentData.vue?vue&type=script&lang=js"
import style0 from "./appointmentData.vue?vue&type=style&index=0&id=40e6a6ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e6a6ce",
  null
  
)

export default component.exports